import { Component, EventEmitter, Input, OnDestroy, Output, OnInit } from '@angular/core';

/**
 * Rxjs Imports
 */
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
/**
 * Model imports
 */
import { Community } from '../../onboarding/interface/global.model';
/**
 * Constant imports
 */
import { NUMBERS, COMMUNITY_USER_TYPE, COMMUNITY_JOIN_TYPE, ERROR_CODES, CAROUSEL, PRODUCT_TYPE_CONSTANT, SCREEN_NAME, ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME } from '../../constants/app.constants';
/**
 * Service imports
 */
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { Router } from '@angular/router';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';

@Component({
  selector: 'app-public-community-card-item',
  templateUrl: './public-community-card-item.component.html',
  styleUrls: ['./public-community-card-item.component.scss']
})
export class PublicCommunityCardItemComponent implements OnInit, OnDestroy {

  @Input() index: number;
  @Input() pCommunity: Community;
  @Input() viewMore = false;
  @Input() offset: number;
  @Input() isRequestWithdrawn = false;
  @Input() callingFrom = '';
  @Input() screenFrom = '';
  @Input() totalCommunity : number;
  @Input() carouselType : string;

  /**
   * Emit the filter key outside.
   * @emitReloadCommunityList emits reload community list event
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() emitViewAll: EventEmitter<any> = new EventEmitter();
  @Output() emitCommunityDetail: EventEmitter<string> = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() emitWithdrawRequest: EventEmitter<any> = new EventEmitter();
  @Output() emitReloadCommunityList: EventEmitter<boolean> = new EventEmitter();
  /**
   * @notifier$ defines a notifier subject stream to end data streaming
   * @communityUserType community user type
   * @communityJoinType community join type
   * @number Number constant
   * @loader ongoing request
   * @withdrawRequest request
   * Is community active.
   */
 private notifier$ = new Subject();
 public communityUserType = COMMUNITY_USER_TYPE;
 public communityJoinType = COMMUNITY_JOIN_TYPE;
 public numbers = NUMBERS;
 public loader = false;
 public withdrawRequest = false;
 public callFrom = CAROUSEL.GRANDROUND;
 public isCommunityActive = NUMBERS.ONE;
 public carousel = CAROUSEL;
 /**
  * Constant for screen names
  */
 public screenName = SCREEN_NAME;


  /**
   * Analytics session time.
   */
  private sessiontime = { 'start_time': '', 'end_time': '' };


  /**
   * Necessary instances.
   */
  constructor(
    private fnCollectionService: FunCollectionService,
    public mls: NewLanguageService,
    private analyticSdk: Analytics,
    public router: Router) {}

  ngOnInit(): void {
    if (this.pCommunity) {
      this.requestWithdrawStatus();
    }
  }

  /**
   * view all button is enabled or not
   */
  get isViewAll(): boolean {
    return ((this.index === NUMBERS.TEN && this.offset > NUMBERS.ONE && this.viewMore) || ((this.index !== NUMBERS.NINE) && (this.screenFrom === this.callFrom) && (this.index === this.totalCommunity - (NUMBERS.ONE))));
  }


  /**
   * Event handler for join public community
   */
  joinCommunityHandler(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,this.pCommunity?.da_id,this.callingFrom !== '' ? this.callingFrom : SCREEN_NAME.GR_PUBLIC_CAROUSEL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.JOIN_COMMUNITY, null);
    this.loader = true;
    this.fnCollectionService.joinPublicCommunity(this.pCommunity.id).pipe(
      takeUntil(this.notifier$)
    ).subscribe(response => {
      this.loader = false;
      if (response.status === NUMBERS.ONE) {
        this.fnCollectionService.showSuccess(this.mls.languageText.toster.key2, this.mls.languageText.toster.key2);
        this.fnCollectionService.navigateToCommunityDetailPage(this.pCommunity.id);
      } else {
        this.fnCollectionService.errorHandeler(response);
      }
    },
      (error) => {
        this.loader = false;
        this.fnCollectionService.errorHandeler(error);
      });
  }

  /**
   * Event handler for request to admin to join public community
   */
  requestToJoinHandler(action: string): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,this.pCommunity?.da_id,this.callingFrom !== '' ? this.callingFrom : SCREEN_NAME.GR_PUBLIC_CAROUSEL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.COMMUNITY_JOIN_REQUEST, null);
    this.loader = true;
    this.fnCollectionService.joinPublicCommunity(this.pCommunity.id, action).pipe(
      takeUntil(this.notifier$)
    ).subscribe(response => {
      this.loader = false;
      if (response.status === this.numbers.ONE && response.code === this.numbers.TWO_THOUSAND) {
        this.fnCollectionService.showSuccess(this.mls.languageText.community.key89, this.mls.languageText.toster.key2);
        this.withdrawRequest = true;
      }
      if (response.error && response.error.code === ERROR_CODES.ALREADY_EXIST) {
        this.fnCollectionService.showSuccess(response.error.msg, this.mls.languageText.toster.key2);
        this.withdrawRequest = false;
        this.emitReloadCommunityList.emit(true);
      }
    });
  }

  /**
   * Join community on conditional base.
   */
  joinCommunity(): void {
    const start_time = new Date().getTime().toString();

    if (this.withdrawRequest || this.pCommunity?.request?.response === NUMBERS.TWO) {
      const request = { openModal: this.withdrawRequest || this.pCommunity?.request?.response === NUMBERS.TWO, community: this.pCommunity, callingFrom: this.callingFrom };
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,this.pCommunity?.da_id,this.callingFrom !== '' ? this.callingFrom : SCREEN_NAME.GR_PUBLIC_CAROUSEL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.WITHDRAW_REQUEST, null);
      this.emitWithdrawRequest.emit(request);
    } else {

      this.pCommunity?.join_type === this.communityJoinType.APPROVAL
        ? this.requestToJoinHandler(this.numbers.ONE.toString())
        : this.joinCommunityHandler();

      if (this.pCommunity?.join_type === COMMUNITY_JOIN_TYPE.APPROVAL) {
        this.sessiontime.start_time = new Date().getTime().toString();

      } else if (this.pCommunity?.join_type === COMMUNITY_JOIN_TYPE.AUTOMATIC) {
        this.sessiontime.start_time = new Date().getTime().toString();
      }
    }
  }

  /**
   * Withdraw actions to get on card CTA click.
   */
  requestWithdrawStatus(): void {
    this.fnCollectionService.getWithdrawStatus.pipe(
      takeUntil(this.notifier$),
      filter(community => community['community'].id === this.pCommunity.id))
      .subscribe(community => {
        this.loader = true;
        if (community) {
          this.fnCollectionService.joinPublicCommunity(
            this.pCommunity.id,
            this.numbers.ZERO.toString()).pipe(
              takeUntil(this.notifier$)
            ).subscribe(response => {
              this.loader = false;
              if (response.status === this.numbers.ONE && response.code === this.numbers.TWO_THOUSAND) {
                community['community'].request.response = this.numbers.ZERO;
                community['community'].request.type = '';
                this.fnCollectionService.showSuccess(this.mls.languageText.community.key90, this.mls.languageText.toster.key2);
                this.withdrawRequest = false;
              }
              if (response.error && response.error.code === ERROR_CODES.ALREADY_EXIST) {
                this.fnCollectionService.showSuccess(response.error.msg, this.mls.languageText.toster.key2);
                this.emitReloadCommunityList.emit(true);
              }
            },
              (error) => {
                this.loader = false;
                this.fnCollectionService.errorHandeler(error);
              });
        }
      });
  }

  /**
   * Card CTA text.
   */
  get cardActionText(): string {
    return (this.pCommunity?.join_type === this.communityJoinType.APPROVAL
      ? (this.withdrawRequest || this.pCommunity?.request?.response === NUMBERS.TWO ? this.mls.languageText.community.key88 : this.mls.languageText.community.key103)
      : this.mls.languageText.community.key72);
  }

  /**
   * Emits view all btn click event
   */
  viewAllHandler(): void {
    if (this.carouselType === CAROUSEL.MY_COMMUNITY_CAROUSEL) {
    this.fnCollectionService.navigateToCommunityListing(CAROUSEL.MY_COMMUNITY_CAROUSEL);
    } else {
    this.emitViewAll.emit();
   }
  }

  /**
   * emits navigate to community detail page navigation
   */
  navigateToDetailHandler(): void {
    this.emitCommunityDetail.emit(this.pCommunity.id);
    /**
     * Set analytics data for analytics event.
     */
    if (this.callingFrom !== SCREEN_NAME.COMMUNITY_DASHBOARD && this.carouselType !== CAROUSEL.MY_COMMUNITY_CAROUSEL) { this.generateAnalytic(); }
  }
  /**
   * Method for generating analytics
   */
  generateAnalytic(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.pCommunity?.da_id ?? 0, this.callingFrom ?? SCREEN_NAME.GR_PUBLIC_CAROUSEL, CTA_TYPE.CARD, ACTION_TYPE.CLICK,ACTION_ON.COMMUNITY, null);
  }

  /**
   * For navigating to community detail
   */
  navigateToDetail(): void {
    this.fnCollectionService.navigateToCommunityDetailPage(this.pCommunity.id);
  }
  /**
   * unsubscribes subscriptions
   */
  ngOnDestroy(): void {
    this.notifier$.next();
    this.notifier$.complete();
  }
}
